<div class="agenx-textarea"
  [ngClass]="{'agenx-textarea--error': control.errors && control.touched, 'agenx-textarea--success': control.valid && control.touched}">
  <textarea [id]="idInput" [formControl]="control" class="agenx-textarea__textarea" cols="10" rows="2"></textarea>
  <label [for]="idInput" class="agenx-textarea__label" [ngClass]="labelClasses"> {{ label }} </label>
</div>
